import { Modal } from "react-bootstrap";
import { FiStar, FiTrash2, FiX } from "react-icons/fi";

const ViewTaskModal = ({ show, handleClose }) => {
  return (
    <>
      <Modal show={show} onHide={handleClose} centered size="lg" className="task-modal">
        
        {/* HEADER */}
        <div className="custom-header">
          <div className="header-left">
            <h5>Respond to any pending messages</h5>
            <span className="badge urgent">Urgent</span>
          </div>

          <div className="header-icons">
            <FiStar />
            <FiTrash2 />
            <FiX onClick={handleClose} />
          </div>
        </div>

        <Modal.Body>

          {/* TASK DETAILS */}
          <h6 className="section-title">Task Details</h6>

          <div className="details-box">
            <div className="detail-item">
              <span className="label">Created On</span>
              <span className="value">22 July 2025</span>
            </div>

            <div className="detail-item">
              <span className="label">Due Date</span>
              <span className="value">22 July 2025</span>
            </div>

            <div className="detail-item">
              <span className="label">Status</span>
              <span className="status completed">
                <span className="dot"></span> Completed
              </span>
            </div>
          </div>

          {/* DESCRIPTION */}
          <h6 className="section-title">Description</h6>
          <p className="desc">
            Hiking is a long, vigorous walk, usually on trails or footpaths in the countryside. 
            Walking for pleasure developed in Europe during the eighteenth century. Religious 
            pilgrimages have existed much longer but they involve walking long distances for a 
            spiritual purpose associated with specific religions and also we achieve inner peace 
            while we hike at a local park.
          </p>

          {/* TAGS */}
          <h6 className="section-title">Tags</h6>
          <div className="tags">
            <span className="tag red">Internal</span>
            <span className="tag green">Projects</span>
            <span className="tag dark">Reminder</span>
          </div>

          {/* ASSIGNEE */}
          <h6 className="section-title">Assignee</h6>
          <div className="avatars">
            <img src="/assets/img/profiles/avatar-02-1.jpg" alt="" />
            <img src="/assets/img/profiles/avatar-03.jpg" alt="" />
          </div>

        </Modal.Body>
      </Modal>

      {/* STYLES */}
      <style>{`
        .task-modal .modal-content {
          border-radius: 12px;
          overflow: hidden;
        }

        /* HEADER */
        .custom-header {
          background: #1f2a37;
          color: white;
          padding: 16px 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .header-left {
          display: flex;
          align-items: center;
          gap: 10px;
          flex-wrap: wrap;
        }

        .header-left h5 {
          margin: 0;
          font-size: 18px;
          font-weight: 600;
        }

        .badge.urgent {
          background: red;
          color: white;
          font-size: 12px;
          padding: 4px 8px;
          border-radius: 6px;
        }

        .header-icons {
          display: flex;
          gap: 14px;
          font-size: 18px;
          cursor: pointer;
        }

        /* SECTION */
        .section-title {
          font-weight: 600;
          margin-bottom: 10px;
          margin-top: 10px;
        }

        /* DETAILS BOX */
        .details-box {
          border: 1px solid #eee;
          border-radius: 8px;
          padding: 15px;
          display: flex;
          justify-content: space-between;
          gap: 10px;
          flex-wrap: wrap;
        }

        .detail-item {
          flex: 1;
          min-width: 120px;
          display: flex;
          flex-direction: column;
          gap: 5px;
        }

        .label {
          font-size: 13px;
          color: #666;
        }

        .value {
          font-weight: 500;
        }

        /* STATUS */
        .status.completed {
          background: #e6f9f0;
          color: #22c55e;
          padding: 4px 10px;
          border-radius: 6px;
          font-size: 13px;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          width: fit-content;
        }

        .dot {
          width: 6px;
          height: 6px;
          background: #22c55e;
          border-radius: 50%;
        }

        /* DESCRIPTION */
        .desc {
          color: #555;
          font-size: 14px;
          line-height: 1.6;
        }

        /* TAGS */
        .tags {
          display: flex;
          gap: 10px;
          flex-wrap: wrap;
        }

        .tag {
          padding: 5px 10px;
          border-radius: 6px;
          font-size: 12px;
          color: white;
        }

        .tag.red { background: #ef4444; }
        .tag.green { background: #22c55e; }
        .tag.dark { background: #1f2937; }

        /* AVATARS */
        .avatars {
          display: flex;
        }

        .avatars img {
          width: 35px;
          height: 35px;
          border-radius: 50%;
          border: 2px solid white;
          margin-right: -10px;
        }

        /* MOBILE */
        @media (max-width: 768px) {
          .custom-header {
            flex-direction: column;
            align-items: flex-start;
            gap: 10px;
          }

          .header-icons {
            align-self: flex-end;
          }

          .details-box {
            flex-direction: column;
          }

          .avatars img {
            width: 30px;
            height: 30px;
          }
        }
      `}</style>
    </>
  );
};

export default ViewTaskModal;